const gpuSpecs = [
  {
    model: "NVIDIA B200",
    count: "8",
    vram: "180",
    ram: "2,048",
    storage: "61.44",
  },
  {
    model: "NVIDIA RTX PRO 6000",
    count: "8",
    vram: "96",
    ram: "1,024",
    storage: "7.68",
  },
  {
    model: "NVIDIA HGX H200",
    count: "8",
    vram: "141",
    ram: "2,048",
    storage: "61.44",
  },
];

export default function GpuTableSection() {
  return (
    <section className="px-4 md:px-6 py-16 md:py-24 bg-background-100 border-y border-background-200">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Flexible GPU Instance Configuration on Demand
          </h2>
          <p className="mt-4 text-foreground-600 max-w-2xl mx-auto">
            Utilize on-demand GPU instances to handle additional workloads.
            You can flexibly and quickly launch burst capacity services with
            extremely competitive pricing.
          </p>
        </div>

        <div className="overflow-x-auto rounded-lg border border-background-200 bg-background-50">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200 bg-background-100">
                <th className="px-6 py-4 text-left font-semibold text-foreground-800 whitespace-nowrap">
                  GPU Model
                </th>
                <th className="px-6 py-4 text-center font-semibold text-foreground-800 whitespace-nowrap">
                  GPU Count
                </th>
                <th className="px-6 py-4 text-center font-semibold text-foreground-800 whitespace-nowrap">
                  VRAM (GB)
                </th>
                <th className="px-6 py-4 text-center font-semibold text-foreground-800 whitespace-nowrap">
                  RAM (GB)
                </th>
                <th className="px-6 py-4 text-center font-semibold text-foreground-800 whitespace-nowrap">
                  Storage (TB)
                </th>
              </tr>
            </thead>
            <tbody>
              {gpuSpecs.map((g) => (
                <tr
                  key={g.model}
                  className="border-b border-background-200 last:border-b-0 hover:bg-background-50/50"
                >
                  <td className="px-6 py-4 font-medium text-foreground-950 whitespace-nowrap">
                    {g.model}
                  </td>
                  <td className="px-6 py-4 text-center text-foreground-700 whitespace-nowrap">
                    {g.count}
                  </td>
                  <td className="px-6 py-4 text-center text-foreground-700 whitespace-nowrap">
                    {g.vram}
                  </td>
                  <td className="px-6 py-4 text-center text-foreground-700 whitespace-nowrap">
                    {g.ram}
                  </td>
                  <td className="px-6 py-4 text-center text-foreground-700 whitespace-nowrap">
                    {g.storage}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}